/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkResubmitRequestDto } from '../../models/bulk-resubmit-request-dto';
import { BulkResubmitResponseDto } from '../../models/bulk-resubmit-response-dto';

export interface IdpSubmissionBulkResubmitPost$Params {
  body: BulkResubmitRequestDto;
}

export function idpSubmissionBulkResubmitPost(
  http: HttpClient,
  rootUrl: string,
  params: IdpSubmissionBulkResubmitPost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<BulkResubmitResponseDto>> {
  const rb = new RequestBuilder(rootUrl, idpSubmissionBulkResubmitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(rb.build({ responseType: 'json', accept: 'application/json', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<BulkResubmitResponseDto>),
    );
}

idpSubmissionBulkResubmitPost.PATH = '/IdpSubmission/BulkResubmit';
